const KEY = '6SXBZ-RVL6C-LVC24-AQHCM-YMBYQ-UCF4P';

// JSONP 工具函数
export const jsonp = (url) => {
  return new Promise((resolve, reject) => {
    const callbackName = 'jsonp_' + Math.round(100000 * Math.random());
    const script = document.createElement('script');

    window[callbackName] = (data) => {
      delete window[callbackName];
      document.body.removeChild(script);
      resolve(data);
    };

    script.src = `${url}&callback=${callbackName}&output=jsonp`;
    script.onerror = () => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('网络请求失败'));
    };
    document.body.appendChild(script);
  });
};

// 加载腾讯地图脚本
export const loadMapScript = () => {
  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector('script[src*="map.qq.com/api/gljs"]');
    if (existingScript) {
      document.head.removeChild(existingScript);
    }
    if (window.TMap) {
      window.TMap = undefined;
    }

    const script = document.createElement('script');
    script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${KEY}`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('地图加载失败'));
    document.head.appendChild(script);
  });
};

// 获取用户当前位置
export const getUserLocation = () => {
  return new Promise(async (resolve) => {
    if ('geolocation' in navigator) {
      try {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            try {
              const data = await jsonp(
                `https://apis.map.qq.com/ws/geocoder/v1?location=${latitude},${longitude}&key=${KEY}`
              );
              if (data.status === 0 && data.result) {
                resolve({
                  latitude,
                  longitude,
                  address: data.result.formatted_addresses?.recommend || data.result.address
                });
              } else {
                resolve({
                  latitude,
                  longitude,
                  address: `${latitude.toFixed(6)},${longitude.toFixed(6)}`
                });
              }
            } catch (error) {
              console.error('Geocoding error:', error);
              resolve({
                latitude,
                longitude,
                address: `${latitude.toFixed(6)},${longitude.toFixed(6)}`
              });
            }
          },
          async (error) => {
            console.error('Geolocation error:', error);
            const ipLocation = await getIPLocation();
            resolve(ipLocation);
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
        );
      } catch (error) {
        console.error('Geolocation error:', error);
        const ipLocation = await getIPLocation();
        resolve(ipLocation);
      }
    } else {
      const ipLocation = await getIPLocation();
      resolve(ipLocation);
    }
  });
};

// IP定位作为备选方案
export const getIPLocation = async () => {
  try {
    const data = await jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=${KEY}`);
    if (data.status === 0 && data.result) {
      const { location } = data.result;
      return {
        latitude: location.lat,
        longitude: location.lng,
        address: data.result.ad_info.location
      };
    } else {
      console.error('IP location failed:', data.message);
      return null;
    }
  } catch (error) {
    console.error('IP location error:', error);
    return null;
  }
}; 